import React, { useEffect } from "react";
import { LandingLanguageProvider } from "./i18n/LandingLanguage";
import { LandingChromeProvider } from "./LandingChrome";
import SiteHeader from "./inicio/SiteHeader";
import SiteFooter from "./inicio/SiteFooter"; // [ULTURE] pie de la home (antes FooterLanding)
import CursorGlow from "./components/CursorGlow";
import WhatsAppFloat from "./components/WhatsAppFloat";
import "./landing-tokens.css";
import "./landing-keyframes.css";

// Layout de la landing nueva (Ulture.co Web): header + footer siempre visibles,
// glow de cursor y botón flotante de WhatsApp (referencia: div raíz línea 178).
export default function LandingLayout({ children }: { children: React.ReactNode }) {
  // ── Nada por debajo del wordmark animado (móvil y tablet) ──
  // El documento ya termina EXACTAMENTE en el panel del wordmark (hueco medido
  // tras el footer: 0px). Lo que dejaba "seguir bajando" era el rebote elástico
  // del navegador, que arrastra la página más allá del final y enseña el fondo
  // blanco del layout. overscroll-behavior: none lo corta.
  // Solo táctil (<1080px): en escritorio no hay rebote y no se toca nada.
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtml = html.style.overscrollBehavior;
    const prevBody = body.style.overscrollBehavior;
    const mq = window.matchMedia("(max-width: 1079px)");
    const apply = () => {
      const on = mq.matches;
      html.style.overscrollBehavior = on ? "none" : prevHtml;
      body.style.overscrollBehavior = on ? "none" : prevBody;
    };
    apply();
    mq.addEventListener("change", apply);
    return () => {
      mq.removeEventListener("change", apply);
      html.style.overscrollBehavior = prevHtml;
      body.style.overscrollBehavior = prevBody;
    };
  }, []);

  return (
    <LandingLanguageProvider>
      <LandingChromeProvider>
        <div
          data-product="pest"
          data-landing-root=""
          style={{
            position: "relative", minHeight: "100vh", display: "flex", flexDirection: "column",
            background: "#ffffff", fontFamily: "var(--font-body, 'Mulish'), sans-serif",
          }}
        >
          <SiteHeader />
          {children}
          <SiteFooter />
          <CursorGlow />
          <WhatsAppFloat />
        </div>
      </LandingChromeProvider>
    </LandingLanguageProvider>
  );
}
